import { NgModule } from "@angular/core";
import { SiqCommonModule } from "./siq-common.module";
import { PopupComponent } from "./components/popup/popup.component";
import { SiqButtonComponent } from "./standalone-components/siq-button/siq-button.component";

const components = [PopupComponent];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    SiqCommonModule,
    SiqButtonComponent
  ],
  exports: [
    ...components
  ]
})
export class ModalModule { }